import { ErrorType, ICancelMembershipAutoPayApiRequest } from '../../shared/types';
import { CancelMembershipAutoPay } from '../contracts';
import axios from 'axios';
import CookieHelper from '../../utils/cookieHelper';
import { createAxiosConfig } from '../createAxiosConfig';
import { LogCannon } from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const CancelMembershipAutoPayApi =
  (endpoint: string): CancelMembershipAutoPay =>
  async (request: ICancelMembershipAutoPayApiRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      const { data } = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));
      return Promise.resolve(data);
    } catch (error: any) {
      LogCannon.error('CancelMembershipAutoPayApi error', error);
      let type = ErrorType.SYSTEM_ERROR;

      if (error.response) {
        const statusCode = error?.response?.status;
        const errorMessage = error?.response.data?.message || error?.message || error?.response?.data?.error?.message;
        if (statusCode === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.SESSION_TIMEOUT,
          });
        }

        if (statusCode === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.AUTH_ERROR,
          });
        }
      }

      return Promise.reject({ type, message: error.message });
    }
  };
